import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedUser: {},
  showUserDrawer: false,
};

const userDrawerSlice = createSlice({
  name: 'providerDrawer',
  initialState,
  reducers: {
    setSelectedUser: (state, { payload }) => {
      state.selectedUser = payload;
    },
    setShowUserDrawer: (state, { payload }) => {
      state.showUserDrawer = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: userDrawerReducer } = userDrawerSlice;
export const { setShowUserDrawer, setSelectedUser } = userDrawerSlice.actions;
